import "../sentry";
import * as Sentry from "@sentry/react";
import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter as Router} from 'react-router-dom';
import ThemeProvider from './mosaic/utils/ThemeContext';
import DatixoApplication from './DatixoApplication.jsx';
import GlobalContextProvider from "./utils/context/GlobalContextProvider.jsx";
import {Toaster} from "react-hot-toast";
import {GoogleOAuthProvider} from "@react-oauth/google";
import DashboardFilterContextProvider from "./components/filters/DashboardFilterContextProvider.jsx";
import {DataGrid2Provider} from "./components/datagrid/DataGrid2Context.jsx";

createRoot(document.getElementById('root')).render(
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
        <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
            <React.StrictMode>
                <Toaster
                    position="bottom-left"
                />
                <DataGrid2Provider>
                    <Router>
                        <ThemeProvider>
                            <GlobalContextProvider>
                                <DashboardFilterContextProvider>
                                    <DatixoApplication/>
                                </DashboardFilterContextProvider>
                            </GlobalContextProvider>
                        </ThemeProvider>
                    </Router>
                </DataGrid2Provider>
            </React.StrictMode>
        </GoogleOAuthProvider>
    </Sentry.ErrorBoundary>
);
